import React from "react";
import ReactPaginate from "react-paginate";
import styles from "./Pagination.module.scss";
import { scrollToTop } from "../../../../../../CloudStorage/CommonFunction";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function EntryPagination({ totalitemcounts, size, pageNumber, setPageNumber }) {
  const pageCount = Math.ceil(totalitemcounts / size);

  if (pageCount <= 1) {
    return null;
  }

  const handlePageClick = (event) => {
    setPageNumber(event.selected);
    scrollToTop();
  };

  return (
    <div className={styles["pagination-container"]}>
      <ReactPaginate
        breakLabel="..."
        nextLabel={pageNumber < pageCount - 1 ? <FaChevronRight /> : null}
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel={pageNumber > 0 ? <FaChevronLeft /> : null}
        marginPagesDisplayed={2}
        containerClassName="pagination"
        activeClassName={styles.active}
        initialPage={pageNumber}
        forcePage={pageNumber}
      />
    </div>
  );
}

export default EntryPagination;
